import React, {useState} from "react";
import {Menu, MenuItem, Sidebar, sidebarClasses, SubMenu} from "react-pro-sidebar";
import {FaCalendarAlt, FaClipboardList, FaExpand, FaUsers} from "react-icons/fa";
import "react-circular-progressbar/dist/styles.css";
import {FaMinimize} from "react-icons/fa6";

export default function DashboardSidebar({onMenuSelect}) {
    const [isCollapsed, setIsCollapsed] = useState(false);

    return (
        <Sidebar
            collapsed={isCollapsed}
            collapsedWidth={"80px"}
            width={"250px"}
            rootStyles={{
                [`.${sidebarClasses.container}`]: {
                    background: "linear-gradient(to bottom, " +
                        "#9EAFF1FF, #fff)",
                    color: "#9eaff1",
                },
            }}
        >
            <Menu
                menuItemStyles={{
                    button: ({level, active}) => {
                        if (level === 0)
                            return {
                                color: "#ffffff",
                                background: active ? "linear-gradient(to bottom, #1d34a3, #5f7afb)" : undefined,
                                "&:hover": {
                                    backgroundColor: "#273b8e",
                                },
                            };
                        else
                            return {
                                color: "#ffffff",
                                background: active ? "linear-gradient(to bottom, #1d34a3, #7a8ded)" : undefined,
                                "&:hover": {
                                    background: "linear-gradient(to bottom, #1d34a3, #7a8ded)",
                                },
                            };
                    },
                    icon: ({active}) => {
                        return {
                            color: active ? "#ffffff" : "#000000",
                        };
                    },
                    label: ({active}) => {
                        return {
                            color: active ? "#ffffff" : "#000000",
                        };
                    },
                    root: ({active}) => {
                        return {
                            display: "block",
                        };
                    },
                }}
            >
                {/* Toggle */}
                <MenuItem
                    icon={isCollapsed ? <FaExpand/> : <FaMinimize/>}
                    onClick={() => setIsCollapsed(!isCollapsed)}
                    style={{
                        backgroundColor: "rgba(109,110,112,0.96)",
                        color: "#fff",
                        border: "none",
                        padding: "10px",
                        cursor: "pointer",
                        width: "100%",
                        textAlign: "center",
                    }}
                >
                    {isCollapsed ? "Genişlet" : "Daralt"}
                </MenuItem>

                {/* Dashboard Sections */}
                <MenuItem icon={<FaClipboardList/>} onClick={() => onMenuSelect("dashboard")}>
                    YÖNETİM PANELİ
                </MenuItem>

                <SubMenu icon={<FaUsers/>} label="Katılımcılar">
                    <MenuItem onClick={() => onMenuSelect("participants_all")}>Tüm Katılımcılar</MenuItem>
                    <MenuItem onClick={() => onMenuSelect("student_create")}>Yeni Katılımcı Ekle</MenuItem>
                    <MenuItem onClick={() => onMenuSelect("course_participants_by_course")}>Kurs Katılımcıları</MenuItem>

                    {/*<MenuItem onClick={() => onMenuSelect("participants_pending")}>Onay Bekleyen</MenuItem>
                    <MenuItem onClick={() => onMenuSelect("participants_unpaid")}>Ödeme Bekleyen</MenuItem>*/}
                </SubMenu>

                <SubMenu icon={<FaCalendarAlt/>} label="Dönemler">
                    <MenuItem onClick={() => onMenuSelect("periods_all")}>Dönem Listesi</MenuItem>
                    <MenuItem onClick={() => onMenuSelect("term_create")}>Yeni Dönem Ekle</MenuItem>
                </SubMenu>
                <SubMenu icon={<FaClipboardList/>} label="Eğitimler">
                    <MenuItem onClick={() => onMenuSelect("courses_all")}>Tüm Eğitimler</MenuItem>
                    <MenuItem onClick={() => onMenuSelect("course_create")}>Yeni Eğitim Ekle</MenuItem>
                    <MenuItem onClick={() => onMenuSelect("course_details_add")}>Eğitim Detaylarını Düzenle</MenuItem>
                    <MenuItem onClick={() => onMenuSelect("course_participants")}>Eğitim Detayları</MenuItem>
                </SubMenu>
                <SubMenu icon={<FaClipboardList/>} label="Sınavlar">
                    <MenuItem onClick={() => onMenuSelect("exams_all")}>Tüm Sınavlar</MenuItem>
                    <MenuItem onClick={() => onMenuSelect("exam_create")}>Yeni Sınav Ekle</MenuItem>
                    <MenuItem onClick={() => onMenuSelect("exam_results_by_participant")}>Öğrenci Bazlı Sınav
                        Sonuçları</MenuItem>
                    <MenuItem onClick={() => onMenuSelect("exam_results_by_exam")}>Sınav Bazlı Sonuçlar</MenuItem>
                    <MenuItem onClick={() => onMenuSelect("answer_details")}>Sınav Yanıtları</MenuItem>
                </SubMenu>
                <SubMenu icon={<FaClipboardList/>} label="Soru Yönetimi">
                    <MenuItem onClick={() => onMenuSelect("questions")}>Sorular</MenuItem>
                    <MenuItem onClick={() => onMenuSelect("question_create")}>Yeni Soru Ekle</MenuItem>
                    <MenuItem onClick={() => onMenuSelect("question_groups")}>Soru Grupları</MenuItem>
                    <MenuItem onClick={() => onMenuSelect("question_group_create")}>Yeni Soru Grubu Ekle</MenuItem>

                </SubMenu>
                <SubMenu icon={<FaClipboardList/>} label="ML">
                    <MenuItem onClick={() => onMenuSelect("prediction")}>Katılımcı Başarı Tahmini</MenuItem>

                </SubMenu>
            </Menu>
        </Sidebar>
    );
}
